import Layout from '@/components/layout/Layout';
import { PaymentCardContent } from '@/components/tax-refund/payment-card/PaymentCardContent';

function PaymentCardPage() {
  return (
    <Layout leftIcon={{ icon: 'back' }}>
      <PaymentCardContent />
    </Layout>
  );
}

export default PaymentCardPage;
